import { isPhoneInLandscape, isNotHoverDevice } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import { isHeightConstrained } from '../../styles'
import type { ModalBaseProps } from '..'

export default (config: {
  props: Pick<ModalBaseProps, 'hasImage' | 'width'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  function getModalWidth() {
    switch (props.width) {
      case 'xlarge':
        return '800px'
      case 'large':
        return '640px'
      case 'small':
        return '480px'
      case 'medium':
      default:
        return '480px'
    }
  }

  return {
    default: {
      wrap: {
        boxShadow: tokens.elevationHighest,
        minHeight: props.hasImage ? '512px' : '256px',
        maxWidth: 'calc(100% - 96px)',
        marginTop: '80px',
        maxHeight: 'calc(100vh - 80px * 2)',
        width: getModalWidth(),

        [isPhoneInLandscape]: {
          marginTop: '24px',
          maxHeight: 'calc(100vh - 24px * 2)',
          maxWidth: 'calc(100% - 24px)',
        },

        [isNotHoverDevice]: {
          marginTop: '24px',
          maxHeight: 'calc(100% - 24px * 2)',
        },

        /**
         * This is an arbitraty media added for ImageModal being cut off on
         * short screens to reset back to 256px
         * @see https://docusign.atlassian.net/browse/FRNTEND-1371
         */
        '@media screen and (max-height: 580px)': {
          minHeight: '256px',
        },

        /**
         * This is an arbitrary media query based on height due to the ample
         * whitespace that Ink provides in order to provide more space to show
         * the entirety of the modal
         */
        '@media screen and (max-height: 515px)': {
          marginTop: '24px',
          maxHeight: 'calc(100vh - 24px * 2)',
        },

        [isHeightConstrained]: {
          height: '100%',
          marginTop: '8px',
          maxHeight: 'calc(100vh - 8px * 2)',
          maxWidth: 'calc(100% - 8px * 2)',
          minHeight: 'inherit',
          overflowY: 'auto',
        },
      },

      close: {
        insetInlineEnd: '16px',
        top: '16px',
      },

      modalBase: {
        minHeight: '254px',
      },
    },
  } as const
}
